import parsePhoneNumberFromString from 'libphonenumber-js';
import * as yup from 'yup';
import i18n from 'Utilities/i18n';
const yupSchema = () => {
  return yup.object().shape({
    otp: yup.string(),
    mobileNumber: yup.string().required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).min(7, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).test('test-valid-phone', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'), value => {
      var _parsePhoneNumberFrom;
      return ((_parsePhoneNumberFrom = parsePhoneNumberFromString(value ?? '', {
        extract: false
      })) === null || _parsePhoneNumberFrom === void 0 ? void 0 : _parsePhoneNumberFrom.isValid()) ?? false;
    })
  });
};
export default yupSchema;